import { Fragment } from "react";
import { Face } from "../../components/Face";

/** One player as the tablet shows them: the real name, the name the wall is using, the picture. */
export interface Person {
  name: string;
  alias: string | null;
  src: string | null;
}

/** One player on the tablet: their face, then their name, with the wall's name small beneath. */
export function Who({ who }: { who: Person }) {
  return (
    <span className="court-who">
      <Face name={who.name} src={who.src} />
      <span className="court-who-names">
        <span>{who.name}</span>
        {who.alias && <span className="court-alias">{who.alias}</span>}
      </span>
    </span>
  );
}

/** A pair, each with a face: "Luke & Stan". */
export function Team({ team }: { team: Person[] }) {
  return (
    <span className="court-team">
      {team.map((who, i) => (
        <Fragment key={i}>
          {i > 0 && <span>&amp;</span>}
          <Who who={who} />
        </Fragment>
      ))}
    </span>
  );
}
